export default __webpack_public_path__ + "static/media/BigScissorIcon.18cbcdfe.svg";